import React from "react";
import {InputEntryName} from "./components/InputEntryName";
import {InputDragHandle} from "./components/InputDragHandle";
import {InputEditor} from "./components/InputEditor";
import {InputActionArea} from "./components/InputActionArea";

export const InputEntry = (props) => {
    const {value, key, removePort, inputHandle, editButton, inputListCount, children, hideEditor} = props;

    return (
        <div className={`input-area ${value.sectionType}`} data-id={value.id} key={key}>
            <div className="input-container">
                <div className="input">
                    <InputEntryName inputName={value.nodeName}
                                    inputIndex={value.index ?? value.id}/>
                    <InputDragHandle/>
                    {!hideEditor && (
                    <InputEditor value={value}
                                 onBlur={inputHandle}/>
                    )}
                    <InputActionArea value={value}
                                     editButton={editButton}
                                     removePort={removePort}
                                     inputListCount={inputListCount}
                    />
                </div>
                <div className={`input-dropdown ${value.edit ? 'active' : ''}`}>
                    {children}
                </div>
            </div>
        </div>
    )
}